import React from "react";

const ClockGreyIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5059_47661)">
        <path
          d="M9.72168 4.45312V8.90686L12.6908 10.3914"
          stroke="#787878"
          strokeWidth="1.48458"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.72171 16.3301C13.8213 16.3301 17.1446 13.0068 17.1446 8.90726C17.1446 4.80771 13.8213 1.48438 9.72171 1.48438C5.62217 1.48438 2.29883 4.80771 2.29883 8.90726C2.29883 13.0068 5.62217 16.3301 9.72171 16.3301Z"
          stroke="#787878"
          strokeWidth="1.48458"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5059_47661">
          <rect
            width="17.8149"
            height="17.8149"
            fill="white"
            transform="translate(0.814453)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ClockGreyIcon;
